import getOpco from "utils/getOpco";

export const API_URL = window.location.origin;

export const PPE_PATH = "/api/v4";

export const ASSETS_URL = `${window.location.origin}/subscriptionplus/${getOpco()}`;
